import React from 'react';
import styled, { keyframes } from 'styled-components';

const DEFAULT_LOADER_SIZE = 48;

const cloverSpin = keyframes`
  0% {
    transform: rotate(0deg) scale(0.96);
  }
  50% {
    transform: rotate(180deg) scale(1.04);
  }
  100% {
    transform: rotate(360deg) scale(0.96);
  }
`;

const LoaderWrap = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Clover = styled.svg`
  width: 100%;
  height: 100%;
  transform-origin: center;
  animation: ${cloverSpin} 1.8s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export default function IHSpinner({ size = DEFAULT_LOADER_SIZE }) {
  return (
    <LoaderWrap size={size} aria-hidden="true">
      <Clover viewBox="0 0 102.49 100.89" focusable="false">
        <path
          fill="#9fcc3b"
          d="M86.54,50.45l9.47-9.47c1.98-1.98,1.98-5.2,0-7.18L67.89,5.68c-1.98-1.98-5.2-1.98-7.18,0l-9.47,9.47 l-9.47-9.47c-1.98-1.98-5.2-1.98-7.18,0L6.48,33.8c-1.98,1.98-1.98,5.2,0,7.18l9.47,9.47l-9.47,9.47c-1.98,1.98-1.98,5.2,0,7.18 L34.6,95.21c1.98,1.98,5.2,1.98,7.18,0l9.47-9.47l9.47,9.47c1.98,1.98,5.2,1.98,7.18,0l28.12-28.12c1.98-1.98,1.98-5.2,0-7.18 L86.54,50.45z"
        />
        <path
          fill="#04a54f"
          d="M40.52,75.02c-1.25-1.25-1.76-3.06-1.35-4.77l2.45-10.18l-10.18,2.45c-1.72,0.41-3.53-0.1-4.77-1.35 L15.94,50.45l-9.47,9.47c-1.98,1.98-1.98,5.2,0,7.18L34.6,95.21c1.98,1.98,5.2,1.98,7.18,0l9.47-9.47L40.52,75.02z"
        />
        <path
          fill="#0c9347"
          d="M57.86,47.58c-0.45-1.85-1.89-3.3-3.75-3.75l-22.67-5.45c-1.72-0.41-3.53,0.1-4.78,1.35L15.94,50.44 l10.72,10.72c1.25,1.25,3.06,1.76,4.78,1.35l22.67-5.45c1.85-0.45,3.3-1.89,3.75-3.75l0.69-2.87L57.86,47.58z"
        />
        <path
          fill="#0c9347"
          d="M48.37,43.83c-1.85,0.45-3.3,1.89-3.75,3.75l-5.45,22.67c-0.41,1.72,0.1,3.53,1.35,4.78l10.72,10.72 l10.72-10.72c1.25-1.25,1.76-3.06,1.35-4.78l-5.45-22.67c-0.45-1.85-1.89-3.3-3.75-3.75l-2.87-0.69L48.37,43.83z"
        />
        <path
          fill="#65bc46"
          d="M44.62,53.32c0.45,1.85,1.89,3.3,3.75,3.75l22.67,5.45c1.72,0.41,3.53-0.1,4.78-1.35l10.72-10.72 L75.82,39.72c-1.25-1.25-3.06-1.76-4.78-1.35l-22.67,5.45c-1.85,0.45-3.3,1.89-3.75,3.75l-0.69,2.87L44.62,53.32z"
        />
        <path
          fill="#65bc46"
          d="M54.11,57.06c1.85-0.45,3.3-1.89,3.75-3.75l5.45-22.67c0.41-1.72-0.1-3.53-1.35-4.78L51.24,15.15 L40.52,25.87c-1.25,1.25-1.76,3.06-1.35,4.78l5.45,22.67c0.45,1.85,1.89,3.3,3.75,3.75l2.87,0.69L54.11,57.06z"
        />
        <path
          fill="#3cae49"
          d="M44.62,53.32c0.45,1.85,1.89,3.3,3.75,3.75l2.87,0.69l2.87-0.69c1.85-0.45,3.3-1.89,3.75-3.75l3-12.49 l-12.49,3c-1.85,0.45-3.3,1.89-3.75,3.75l-0.69,2.87L44.62,53.32z"
        />
        <path
          fill="#168241"
          d="M54.11,57.06c1.85-0.45,3.3-1.89,3.75-3.75l0.69-2.87l-0.69-2.87c-0.45-1.85-1.89-3.3-3.75-3.75l-12.49-3 l3,12.49c0.45,1.85,1.89,3.3,3.75,3.75l2.87,0.69L54.11,57.06z"
        />
        <path
          fill="#168241"
          d="M48.37,43.83c-1.85,0.45-3.3,1.89-3.75,3.75l-0.69,2.87l0.69,2.87c0.45,1.85,1.89,3.3,3.75,3.75l12.49,3 l-3-12.49c-0.45-1.85-1.89-3.3-3.75-3.75l-2.87-0.69L48.37,43.83z"
        />
        <path
          fill="#168241"
          d="M57.86,47.58c-0.45-1.85-1.89-3.3-3.75-3.75l-2.87-0.69l-2.87,0.69c-1.85,0.45-3.3,1.89-3.75,3.75l-3,12.49 l12.49-3c1.85-0.45,3.3-1.89,3.75-3.75l0.69-2.87L57.86,47.58z"
        />
        <path
          fill="#0b763c"
          d="M57.86,47.58c-0.45-1.85-1.89-3.3-3.75-3.75l-2.87-0.69l-2.87,0.69c-1.85,0.45-3.3,1.89-3.75,3.75l-0.69,2.87 l0.69,2.87c0.45,1.85,1.89,3.3,3.75,3.75l2.87,0.69l2.87-0.69c1.86-0.45,3.3-1.89,3.75-3.75l0.69-2.87L57.86,47.58z"
        />
      </Clover>
    </LoaderWrap>
  );
}
